import React, { useState, useEffect } from 'react';
import { FiUsers, FiShield, FiDatabase, FiBarChart2, FiSettings, FiGlobe, FiMonitor } from 'react-icons/fi';
import config from '../../config/frontend.config';
import './AdminPanel.css';

function AdminPanel() {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalTeams: 0,
    activeUsers: 0,
    systemHealth: 'Good'
  });

  const [recentActivity, setRecentActivity] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load admin panel data
    loadAdminData();
  }, []);

  const loadAdminData = async () => {
    try {
      setLoading(true);
      // Here you would make API calls to get admin data
      // For now, using mock data
      setStats({
        totalUsers: 1250,
        totalTeams: 89,
        activeUsers: 856,
        systemHealth: 'Good'
      });

      setRecentActivity([
        {
          id: 1,
          action: 'User Login',
          user: 'John Doe',
          timestamp: '2024-01-15 10:30:00',
          type: 'login'
        },
        {
          id: 2,
          action: 'Team Created',
          user: 'Jane Smith',
          timestamp: '2024-01-15 09:15:00',
          type: 'create'
        },
        {
          id: 3,
          action: 'Email Campaign Sent',
          user: 'Mike Johnson',
          timestamp: '2024-01-15 08:45:00',
          type: 'email'
        }
      ]);
    } catch (error) {
      console.error('Error loading admin data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getActivityIcon = (type) => {
    switch (type) {
      case 'login':
        return <FiUsers className="activity-icon login" />;
      case 'create':
        return <FiShield className="activity-icon create" />;
      case 'email':
        return <FiBarChart2 className="activity-icon email" />;
      default:
        return <FiSettings className="activity-icon default" />;
    }
  };

  if (loading) {
    return (
      <div className="admin-panel">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading Admin Panel...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h1>Admin Panel</h1>
        <p>System administration and monitoring dashboard</p>
      </div>

      <div className="admin-stats-grid">
        <div className="stat-card">
          <div className="stat-icon">
            <FiUsers />
          </div>
          <div className="stat-content">
            <h3>{stats.totalUsers.toLocaleString()}</h3>
            <p>Total Users</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <FiGlobe />
          </div>
          <div className="stat-content">
            <h3>{stats.totalTeams.toLocaleString()}</h3>
            <p>Total Teams</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <FiBarChart2 />
          </div>
          <div className="stat-content">
            <h3>{stats.activeUsers.toLocaleString()}</h3>
            <p>Active Users</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <FiMonitor />
          </div>
          <div className="stat-content">
            <h3>{stats.systemHealth}</h3>
            <p>System Health</p>
          </div>
        </div>
      </div>

      <div className="admin-content-grid">
        <div className="admin-section">
          <h2>Quick Actions</h2>
          <div className="quick-actions">
            <button className="action-btn">
              <FiUsers />
              <span>Manage Users</span>
            </button>
            <button className="action-btn">
              <FiShield />
              <span>System Settings</span>
            </button>
            <button className="action-btn">
              <FiDatabase />
              <span>Database</span>
            </button>
            <button className="action-btn">
              <FiMonitor />
              <span>Monitoring</span>
            </button>
          </div>
        </div>

        <div className="admin-section">
          <h2>Recent Activity</h2>
          <div className="activity-list">
            {recentActivity.map((activity) => (
              <div key={activity.id} className="activity-item">
                <div className="activity-icon">
                  {getActivityIcon(activity.type)}
                </div>
                <div className="activity-content">
                  <h4>{activity.action}</h4>
                  <p>{activity.user}</p>
                  <span className="activity-time">{activity.timestamp}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPanel; 